<script setup>
import moment from 'moment';
import { computed, ref } from 'vue';
import { useOrderStore } from '@/store/orderStore';
import { useShipmentStore } from '@/store/shipmentStore';
import SelectInput from '@/components/ui/inputs/SelectInput.vue';
import TextInput from '@/components/ui/inputs/TextInput.vue';
import Dropdown from '@/components/ui/Dropdown.vue';

const orderStore = useOrderStore();
const shipmentStore = useShipmentStore();

const selectedDeliveryTypeId = ref(null);
const selectedState = ref({});

const getDiff = computed(() => {
    const startDate = orderStore.getMinPeriodStartDate;
    const start = startDate ? new Date(startDate) : new Date();
    const today = new Date();
    start.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    return Math.ceil((today - start) / (1000 * 60 * 60 * 24));
});

const formattedDateFromToday = computed(() => {
    let startDate = orderStore.getMinPeriodStartDate;
    let today = moment().startOf("day");
    let referenceDate = null;
    startDate = moment(startDate || null).startOf("day");
    if (Math.abs(getDiff.value) >= 7) {
        referenceDate = startDate.subtract(2, "days");
    } else {
        referenceDate = today.add(5, "days");
    }
    return referenceDate.format("MM/DD/YYYY");
});

function selectDeliveryType(id) {
    const findType = _.find(shipmentStore.delivery_types, function (type) {
        return type.id === id;
    });

    if (findType) {
        shipmentStore.setDeliveryTypeForm(findType);
    }
}

function handleState(option) {
    shipmentStore.state = option.name;
}
</script>

<template>
    <div>
        <div class="bg-white p-4 rounded text-sm text-gray-700 border-2 border-sky-300 mb-4">
            {{ $t("purchase-rent-page.shipment.delivery.arrivalInfo").replace("$date", formattedDateFromToday) }}
        </div>

        <span class="w-full inline-block mb-3">Delivery type:</span>
        <Dropdown 
            v-if="shipmentStore.deliveryTypesForDropdown.length"
            class="mb-4"
            v-model="shipmentStore.shipping_type_id"
            :items="shipmentStore.deliveryTypesForDropdown"
            :placeholder="$t('purchase-rent-page.shipment.delivery.typePlaceholder')"
            @select="selectDeliveryType"
        />

        <div
            v-if="shipmentStore.shipping_type_id"
            class="bg-white p-4 rounded text-sm text-gray-700 border-2 border-sky-300 mb-4"
        >
            <p class="text-red-500" v-html="shipmentStore.selectedDeliveryType.description"></p>
        </div>

        <text-input
            class="mb-4"
            :label="$t('order.address')"
            v-model="shipmentStore.address"
            :placeholder="$t('order.address')"
        />

        <text-input
            class="mb-4"
            :label="$t('order.city')"
            v-model="shipmentStore.city"
            :placeholder="$t('order.city')"
        />

        <text-input
            class="mb-4"
            :label="$t('order.country')"
            :placeholder="$t('order.country')"
            v-model="shipmentStore.country"
        />

        <div class="w-full flex gap-2 flex-wrap sm:flex-nowrap">
            <select-input
                class="flex-1"
                v-model="selectedState"
                :label="$t('order.state')"
                :placeholder="$t('order.state')"
                :options="shipmentStore.usa_states"
                @selected="handleState"
            />

            <text-input
                class="flex-1"
                :label="$t('order.zip')"
                v-model="shipmentStore.zip_code"
                :placeholder="$t('order.zip')"
            />
        </div>
    </div>
</template>